import { Element } from '../../../common/html/element'
import { OVERDUE_TAX_DEBT_TABLES } from '../helper'
import classes from './index.module.scss'
import { TableItem } from './TableItem'

export const OverdueTaxDebt = () => {
  return (
    <Element className={classes.container}>
      <TableItem type={OVERDUE_TAX_DEBT_TABLES.OVERDUE_TAX_DEBT_HISTORY} />
      <Element
        className={classes.verticalLine}
        style={{ backgroundColor: '#D5D5D5' }}
      />
      <TableItem type={OVERDUE_TAX_DEBT_TABLES.INVOICE_ENFORCEMENT_HISTORY} />
    </Element>
  )
}
